/** Format a EUR price for display (e.g. 7.99 → €7,99). */
export function formatPrice(price: string | number): string {
  return `€${String(price).replace(".", ",")}`;
}

/** Fallback when portal auth has not returned a price yet. */
export const DEFAULT_TOOL_PRICE_INCL = "7.99";
